/* eslint-disable require-jsdoc */
export default function sessionID() {
  return new Date().getTime() + '.' + Math.random().toString(36).substring(5);
}
